// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"Service_stepsNav__3d1LW","navLink":"Service_navLink__GsuOF","active":"Service_active__245Nx","dragDemo":"Service_dragDemo__3N1LE"};